import type { ReactNode } from "react";

/**
 * LiveRegion Component
 * ARIA live region for announcing dynamic content changes to screen readers
 */

interface LiveRegionProps {
	children: ReactNode;
	/**
	 * Priority level for screen reader announcements
	 * - 'polite': Wait for user to finish current activity (default)
	 * - 'assertive': Interrupt immediately
	 */
	politeness?: "polite" | "assertive";
}

export function LiveRegion({ children, politeness = "polite" }: LiveRegionProps) {
	const role = politeness === "assertive" ? "alert" : "status";

	return (
		<div role={role} aria-live={politeness} aria-atomic="true" className="sr-only">
			{children}
		</div>
	);
}
